// oxlint-disable arrow-body-style
import { useMemo } from "react";

import { useIntl } from "react-intl";

import { getDateDaysFromNow } from "../../../jira/utils";

import { getSuggestionsForTeamType } from "./messages";

export function useSuggestionsForTeamType(teamType: string) {
    const intl = useIntl();

    const suggestions = useMemo(() => {
        return getSuggestionsForTeamType(teamType);
    }, [teamType]);

    const formattedSuggestions = useMemo(() => {
        return suggestions.map((message) => {
            return {
                content: intl.formatMessage(message.content),
                data: {
                    task: intl.formatMessage(message.task),
                    goal: intl.formatMessage(message.goal),
                    dueDate: getDateDaysFromNow(14)
                }
            };
        });
    }, [intl, suggestions]);

    return formattedSuggestions;
}
